module.exports = __webpack_public_path__ + "media/images/game_icon/th/VG1002-1f6d4b92b8b440986117db88a9c26c62.png";